import React from 'react';
import {OrbitComponent} from '../base-components/orbit-component/orbit-component';
import {GameJackpotBox} from "./boxes/root/game-jackpot.box";
import {GameJackpotValueBox} from "./boxes/value/game-jackpot-value.box";
import {CyClass} from "../../../common/cy-classes";
import {observer} from "mobx-react";


export interface GameJackpotComponentProps {
  gameType: number;
  className?: string;
}

export const GameJackpotComponent = observer(
  class GameJackpotComponent extends OrbitComponent<GameJackpotComponentProps> {
    render() {

      const jackpotValue = this.services.jackpots.getGameJackpot(this.props.gameType);
      if(!jackpotValue) {
        return null;
      }

      return (

          <GameJackpotBox className={this.props.className}>
            <GameJackpotValueBox className={CyClass('cy-game-jackpot-amount')}>
              {this.services.currency.formatMoney(jackpotValue)}
            </GameJackpotValueBox>
          </GameJackpotBox>
      );
    }
  }
);
